import { Box } from '@mui/material'
import { ExportProps } from 'features/report/report-constants'
import _ from 'lodash'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import { selectMe } from 'app/slice/user.slice'
import * as UseStyled from 'features/report/useStyled'
import { useSelector } from 'react-redux'


interface FcComponent {
  page: number
  pageLimit: number
  rowCount: number
  sortBy: string
  sortType: string
  data: any
  dataExport: any
  onRequestSort: (sortBy: string, sortType: string) => void
  handleChangeRowsPerPage: (val: any) => void
  handleChangePage: (val: any) => void
  componentRef: any
  headCellsSeconds: any
}
export default function PatientsTreatmentList(props: FcComponent) {
  const { t } = useTranslation()
  const profile = useSelector(selectMe)
  const headCells = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.#NO', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.DATE', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.CN', align: 'center', class: 'text-nowrap', width: '90px' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.PT', align: 'center', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.PATIENT_FULL_NAME', align: 'center' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.PHONE', align: 'center' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.DOCTOR_FULL_NAME', align: 'center' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.OPERATIVE_TYPE', align: 'center' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.OPERATIVE_CODE', align: 'center' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PATIENT_TREATMENT.OPERATIVE', align: 'center' }
  ]

  if (profile?.hasShowPhoneNumber === 'UNPERMISS') {
    headCells.splice(5, 1)
  }

  const renderData = (data: any, no: number, isExport = false) => {
    const num = props.page * props.pageLimit - props.pageLimit + no + 1
    const commonStyle = isExport ? { fontSize: 9 } : {}

    const columns = [
      { option: 'TEXT', align: 'center', label: num, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.date, ...(commonStyle && { style: commonStyle }), class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.cn, ...(commonStyle && { style: commonStyle }), class: 'text-nowrap' },
      { option: 'TEXT', align: 'center', label: data.pt, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.patientFullName, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.phone, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.doctorFullName, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.operativeTypeName, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.operativeCode, ...(commonStyle && { style: commonStyle }) },
      { option: 'TEXT', align: 'left', label: data.operativeName, ...(commonStyle && { style: commonStyle }) }
    ]
    if (profile?.hasShowPhoneNumber === 'UNPERMISS') {
      columns.splice(5, 1)
    }

    return <TableRowCommon key={num.toString()} id={no.toString()} obj={data} columns={columns} />
  }

  return (
    <>
      <Box>
        <UseStyled.ResponsiveReportTable>
          <TableCustom
            tableMinWidth={1920}
            page={props.page}
            pageLimit={props.pageLimit}
            sortType={''}
            sortBy={''}
            rowCount={props.rowCount}
            onSort={props.onRequestSort}
            setPageLimit={props.handleChangeRowsPerPage}
            setPage={props.handleChangePage}
            headCells={headCells}
            rowsData={[
              _.map(props.data.rows, (d: any, index: number) => {
                return renderData(d, index)
              })
            ]}
            customScroll
          />
        </UseStyled.ResponsiveReportTable>
      </Box>
      {/* <div className="print-show" ref={props.componentRef}>
        <NewPatientExport
          headCells={t(`REPORT.REPORT_NAME.PATIENT_TREATMENT`)}
          componant={
            <>
              <table>
                <tr>
                  <TableSortLabel>
                    <td style={{ fontSize: 10, marginLeft: '30px' }}>{t(`REPORT.FILTER.BRANCH`)} : </td>
                    <td style={{ fontSize: 10 }}>{props.headCellsSeconds[0]}</td>
                  </TableSortLabel>
                </tr>
              </table>
              {_.map(_.groupBy(props.dataExport.rows, 'dateOrder'), (data: any, index: number) => {
                return (
                  <Box key={index}>
                    <Box>
                      <UseStyled.Styles className="pt-3">
                        <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '99%', border: 'none' }}>
                          <thead>
                            <tr>
                              {_.map(headCells, (val: any) => {
                                return <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 300 }}> {t(val.labelKey)}</td>
                              })}
                            </tr>
                          </thead>
                          <tbody style={{ fontSize: 10 }}>
                            {data.length > 0 && [
                              _.map(data, (data: any, indexData: number) => {
                                return renderData(data, indexData, true)
                              })
                            ]}
                            {!data.length && <td colSpan={headCells.length}>{t('NOT_FOUND')}</td>}
                          </tbody>
                        </table>
                      </UseStyled.Styles>
                    </Box>
                  </Box>
                )
              })}
            </>
          }
        />
      </div> */}
    </>
  )
}
export function NewPatientExport(props: ExportProps) {
  return (
    <>
      <div className="large" style={{ fontSize: 14 }}>
        {props.headCells}
        {props.headCellsSeconds}
      </div>
      {props.componant}
    </>
  )
}
